<template>
    <div class="detailsContainer">
        <van-row class="detailsWrapper">
            <van-col span="16">
                <div style="color: #d1bdac;font-size: 16px;">{{ $t('activity.cashBackTotal') + " : " }}</div>
                <div class="glowText">{{ formatCurrency(cashbackTotal) }}</div>
            </van-col>
            <van-col span="8">
                <div @click="handleDetailsShow" class="detailIcon">
                    <div class="customText">{{ $t('activity.details') }}</div>
                    <van-icon :name="!showDetails ? 'arrow-down' : 'arrow-up'" />
                </div>
            </van-col>
        </van-row>
        <div v-if="showDetails">
            <div v-if="isShowTodayCard">
                <CashBackHistoryCard :createTime="todayDayRewards.date" :total-amount="todayDayRewards.totalAmount"
                    :istodayClaimed="istodayClaimed" :title="title" :day-list="todayDayRewards.rewards" />
            </div>
            <CashBackHistoryCard v-for="(item, index) in setBetList()" :key="index"
                :createTime="item.lossDate ?? item.createTime" :title="title" :day-count="item.dayCount ?? item.day"
                :activity-status="item.status"
                :total-amount="item.totalBetAmount ?? item.rechargeTotal ?? item.totalBetLoss"
                :istodayClaimed="istodayClaimed" :available-amount="item.remainGiftAmount ?? item.availableAmount"
                :day-list="setdayList(item.dayRewards)" />
        </div>

    </div>
</template>
<script lang="ts" setup>
import { PropType, ref } from 'vue';
import CashBackHistoryCard from './cashBackHistoryCard.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { getBetList, getDayList } from '@/view/components/supportFunction';

const props = defineProps({
    cashbackTotal: {
        type: Number,
        default: () => 0
    },
    betList: {
        type: Array as PropType<any[]>,
        default: () => []
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    type: {
        type: String,
        default: () => ''
    },
    title: String,
    todayDayRewards: {
        type: Object as PropType<any>
    },
    isShowTodayCard: {
        type: Boolean,
        default: () => false
    },
})
const showDetails = ref(false)
const handleDetailsShow = () => {
    showDetails.value = !showDetails.value
}
const setdayList = (data: any) => getDayList(props.type, data)
const setBetList = () => getBetList(props.betList, props.isShowTodayCard)
</script>
<style scoped>
.detailsContainer {
    padding: 5px 15px;
    color: #fff;
}

.detailIcon {
    display: flex;
    justify-content: center;
    padding: 5px;
    border-radius: 10px;
    padding: 6px;
    border-radius: 12px;
    background: #121212;
    border: 1.5px solid transparent;
    background-image:
        linear-gradient(#121212, #121212),
        linear-gradient(to right, #6d5532, #f3e1a0, #6d5532);
    background-origin: border-box;
    background-clip: padding-box, border-box;

    box-shadow: 0 0 10px rgba(181, 143, 86, 0.4);

    color: #b58f56;
    font-family: 'Arial', sans-serif;
    font-size: 13px;
    font-weight: bold;

    cursor: pointer;
    transition: all 0.3s ease;
}

.customText {
    padding-right: 2px;
}

.glowText {
    background: linear-gradient(to bottom, #e0b87e 0%, #a27e4b 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-family: 'Arial Black', sans-serif;
    font-weight: 900;
    filter: drop-shadow(2px 2px 1px rgba(0, 0, 0, 0.5));
    -webkit-font-smoothing: antialiased;
    font-size: 22px;
}

.detailIcon>>>.van-icon {
    font-size: 11px;
    padding: 2px;
    display: flex;
    align-items: center;
}

.detailsWrapper {
    border: 1px solid #c19a6ba6;
    border-radius: 10px;
    background: #23140b;
    padding: 10px 15px;
}
</style>
